import React from "react";
import {
  VerticalTimeline as OriginalVerticalTimeline,
  VerticalTimelineElement as OriginalVerticalTimelineElement,
  VerticalTimelineProps,
  VerticalTimelineElementProps,
} from "react-vertical-timeline-component";

export const VerticalTimeline: React.FC<VerticalTimelineProps> = (props) => {
  const TimelineComponent =
    OriginalVerticalTimeline as React.ComponentType<VerticalTimelineProps>;
  return <TimelineComponent {...props} />;
};

export const VerticalTimelineElement: React.FC<VerticalTimelineElementProps> = (
  props
) => {
  const TimelineElementComponent =
    OriginalVerticalTimelineElement as React.ComponentType<VerticalTimelineElementProps>;
  return <TimelineElementComponent {...props} />;
};